import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import CampCoachesCreateEditForm from './Components/CampCoachesCreateEditForm';
import CampCoachesApi from './CampCoachesApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: CampCoachesCreateEditForm,
                getCreate: CampCoachesApi.create,
                defaults: {},
                successMessage: "Camp Coach Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}